enum LogisticsCompany {
    /**中通快递 */
    ZTO = "ZTO",

    /**中通快运 */
    ZTO56 = "ZTO56",

    /**圆通速递 */
    YTO = "YTO",

    /**申通快递 */
    STO = "STO",

    /**韵达速递 */
    YUNDA = "YUNDA",

    /**韵达快运 */
    YUNDA56 = "YUNDA56",

    /**中国邮政 */
    POST = "POST",

    /**邮政快递包裹 */
    POSTB = "POSTB",

    /**邮政标准快递 */
    POSTS = "POSTS",

    /**EMS */
    EMS = "EMS",

    /**顺丰速运 */
    SF = "SF",

    /**顺丰快运 */
    SFKY = "SFKY",

    /**极兔速递 */
    JT = "JT",

    /**宅急送 */
    ZJS = "ZJS",

    /**百世快递 */
    HTKY = "HTKY",

    /**百世快运 */
    BESTQJT = "BESTQJT",

    /**百世物流 */
    BEST = "BEST",

    /**众邮快递 */
    ZY = "ZY",

    /**京东快运 */
    JDKY = "JDKY",

    /**丰网速运 */
    FENGWANG = "FENGWANG",

    /**安能快递 */
    ANE66 = "ANE66",

    /**安能物流 */
    ANE56 = "ANE56",

    /**京东快递 */
    JD_EXPRESS = "JD_EXPRESS",

    /**京东大件物流 */
    JD_HPCP = "JD_HPCP",

    /**德邦物流 */
    DBL = "DBL",

    /**德邦快递 */
    DBKD = "DBKD",

    /**韵达国际 */
    YUNDAGJ = "YUNDAGJ",

    /**韵达同城 */
    YUNDA_TC = "YUNDA_TC",

    /**申通快运 */
    STO56 = "STO56",

    /** 菜鸟裹裹商家寄件 */
    GGSJJJ = "GGSJJJ",

    /**申通国际 */
    STOGJ = "STOGJ",

    /**中通国际 */
    ZTOGJ = "ZTOGJ",

    /**国通快递 */
    GTO = "GTO",

    /**EMS经济快递 */
    EYB = "EYB",

    /**跨越速运 */
    KUAYUE = "KUAYUE",

    /**安鲜达 */
    EXFRESH = "EXFRESH",

    /**九曳供应链 */
    JIUYESCM = "JIUYESCM",

    /**优速快递 */
    UC = "UC",

    /**万象物流 */
    WXWL = "WXWL",

    /**全锋快递 */
    QFKD = "QFKD",

    /**龙邦快递 */
    LB = "LB",

    /**全一快递 */
    UAPEX = "UAPEX",

    /**快捷快递 */
    FAST = "FAST",

    /**天地华宇 */
    HOAU = "HOAU",

    /**品骏快递 */
    PJBEST = "PJBEST",

    /**如风达快递 */
    RFD = "RFD",

    /**远成快运 */
    YCKY = "YCKY",

    /**壹米滴答 */
    YMDD = "YMDD",

    /**速尔快递 */
    SURE = "SURE",

    /**速通物流 */
    SUT56 = "SUT56",

    /**中铁快运 */
    CRE = "CRE",

    /**亚风 */
    AIR = "AIR",

    /**佳吉快递 */
    CNEX = "CNEX",

    /**联邦快递 */
    FEDEX = "FEDEX",

    /**增益速递 */
    QRT = "QRT",

    /**加运美速递 */
    JYMWL = "JYMWL",

    /**信丰物流 */
    XFWL = "XFWL",

    /**大田物流 */
    DTW = "DTW",

    /**D速物流 */
    DSWL = "DSWL",

    /**承诺达特快 */
    CNDTK = "CNDTK",

    /**运通物流 */
    YTWL = "YTWL",

    /**长宇物流 */
    CYWL = "CYWL",

    /**新邦物流 */
    XBWL = "XBWL",

    /**联昊通 */
    LWT = "LWT",

    /**苏宁物流 */
    SNWL = "SNWL",

    /**能达速递 */
    NDSD = "NDSD",

    /**保宏物流 */
    BHWL = "BHWL",

    /**发网 */
    FW = "FW",

    /**长发 */
    CF = "CF",

    /**远长 */
    YC = "YC",

    /**东方汇 */
    DFH = "DFH",

    /**飞远配送 */
    FYPS = "FYPS",

    /**黑猫宅急便 */
    HMZJB = "HMZJB",

    /**E速宝 */
    ESB = "ESB",

    /**华强物流 */
    HQWL = "HQWL",

    /**安迅物流 */
    AXWL = "AXWL",

    /**中运全速 */
    TOPSPEED = "TOPSPEED",

    /**华企快运 */
    HUAQIEX = "HUAQIEX",

    /**丹鸟 */
    DN = "DN",

    /**都市节奏 */
    DSJZ = "DSJZ",

    /**宽昊物流 */
    KHWL = "KHWL",

    /**顺心捷达 */
    SXJD = "SXJD",

    /**京广速递 */
    SZKKE = "SZKKE",

    /**韵达点通达 */
    YUNDA_DTD = "YUNDA_DTD",

    /**百世云配 */
    BSYP = "BSYP",

    /**运通速运 */
    WTO = "WTO",

    /**沃埃家 */
    WOWVIP = "WOWVIP",

    /**淘特官方物流 */
    TTWLKD = "TTWLKD",

    /**速腾快递 */
    STE56 = "STE56",

    /**安得物流 */
    ANDE = "ANDE",

    /**百世国际 */
    BESTGJ = "BESTGJ",

    /**当当网 */
    DANGDANG = "DANGDANG",

    /**EWE全球快递 */
    EWE = "EWE",

    /**丰云配 */
    FYP = "FYP",

    /**高捷物流 */
    GJWL = "GJWL",

    /**空港宏远电商物流 */
    HYWL = "HYWL",

    /**卡行天下快运 */
    KXTX = "KXTX",

    /**日日顺 */
    RRS = "RRS",

    /**威盛快递 */
    WSKD = "WSKD",

    /**威时沛运 */
    WSPY = "WSPY",

    /**贝海国际速递 */
    XLOBO = "XLOBO",

    /**中远e环球 */
    ZYEHQ = "ZYEHQ",

    /**转运四方物流 */
    ZYSF = "ZYSF",

    /**卓志速运 */
    ZZSY = "ZZSY",

    /**平安达腾飞 */
    PADTF = "PADTF",

    /** 快弟来了 */
    KDLL = "KDLL",

    /** 淘特官方物流兜底 */
    TTWLDD = "TTWLDD",

    /** 哪吒速运 */
    NZSY = "NZSY",

    /** 中通冷链 */
    ZTOCC = "ZTOCC",

    /** 1688官方物流 */
    ALIWL = "ALIWL",

    /** 1688货运 */
    ALIHY = "ALIHY",

    /** 1688官方物流-兜底 */
    ALIWLDD = "ALIWLDD",

    TTSX = "TTSX",

    /** 海信物流 */
    HXWL = "HXWL",

    /** 特急送 */
    TJS = "TJS",

    /** 京东厂家直送 */
    JD_SELLER_DELIVERY = "JD_SELLER_DELIVERY",

    /** 德邦快运 */
    DBKY = "DBKY",

    /** 抖音官方代发快递 */
    /** 如果电子面单号的logisticsCompany为DOUDYIN_EXPRESS需从extraInfo中获取realLogisticsCompany进行展示 */
    DOUYIN_EXPRESS = "DOUYIN_EXPRESS",

    /** 融阅物流 */
    RYWL = "RYWL",

    /** 亿隆速递 */
    YLSD = "YLSD",

    /** 三志物流  */
    SANZHI56 = "SANZHI56",

    /** 快捷快物流 */
    GKSD = "GKSD",

    /** 加运美快递 */
    JYMKD = "JYMKD",

    /** 中邮快运 */
    FJZYWL = "FJZYWL",

    /** 源之安达速运 */
    YADEX = "YADEX",

    /** 中铁智慧物流 */
    ZTZHWL = "ZTZHWL",

    /** 铁中快运 */
    TZKY = "TZKY",

    /** 众邦客物流 */
    SCZB = "SCZB",

    /** 明通国际速递 */
    TNJEX = "TNJEX",

    /** 菜鸟大件物流  */
    CNDJ = "CNDJ",

    /** 吉时达物流 */
    JSD = "JSD",

    /** 捷安信物流 */
    JAX = "JAX",

    /** 汇森优速达 */
    HSYSD = "HSYSD",

    /** 笨鸟速运 */
    BNSY = "BNSY",

    /** 融辉物流 */
    RHWL = "RHWL",

    /** 吉捷国际速递 */
    LUCKYFASTEX = "LUCKYFASTEX",

    /**其他 */
    OTHER = "OTHER",
}

export default LogisticsCompany;
